objectFitImages();
objectFitVideos();

function vPrepHeroAnimation() {
  const title = document.querySelector('.m-hero__title');
  if (getComputedStyle(title).display === 'block')  {
    title.classList.remove("m-hero__title--hidden");
    document
        .querySelector(".m-hero__subtitle-inner")
        .classList.add("anim-entered");
    return;
  }

  const textLeft = document.querySelector(
    ".m-hero__title-left .m-hero__title-inner"
  );
  const textRight = document.querySelector(
    ".m-hero__title-right .m-hero__title-inner"
  );

  const leftWords = textLeft.textContent
    .trim()
    .split(" ")
    .map(word => `<span class="vjs-word-anim">${word}</span>`);
  const rightWords = textRight.textContent
    .trim()
    .split(" ")
    .map(word => `<span class="vjs-word-anim">${word}</span>`);

  textLeft.innerHTML = leftWords.join(" ");
  textRight.innerHTML = rightWords.join(" ");

  anime.set(".m-hero__title-left .vjs-word-anim", {
    translateX: "100%",
    opacity: 0
  });

  anime.set(".m-hero__title-right .vjs-word-anim", {
    translateX: "-100%",
    opacity: 0
  });

  document
    .querySelector(".m-hero__title")
    .classList.remove("m-hero__title--hidden");
}

function vHeroAnimation() {
  const title = document.querySelector('.m-hero__title');
  if (getComputedStyle(title).display === 'block') return;

  anime({
    targets: '.vjs-word-anim',
    translateX: "0%",
    opacity: 1,
    easing: 'cubicBezier(0, 0, .58, 1)',
    duration: 390,
    delay: anime.stagger(320),
    complete: () => {
      document
        .querySelector(".m-hero__subtitle-inner")
        .classList.add("anim-entered");
    }
  });
}

function slideHeroTriangles(triangles, scrollTop, scrollStop) {
  if (scrollTop > scrollStop) {
    triangles.style.transform = `translateY(${scrollStop * 1.5}px)`;
  } else {
    triangles.style.transform = `translateY(${scrollTop * 1.5}px)`;
  }
}

function getTriangleStop(triangles, intro) {
  const winWidth = window.innerWidth;
  const triangleWidth = winWidth / 2;
  const triangleHeight = triangles.getBoundingClientRect().height;
  const targetWidth = intro.getBoundingClientRect().width;

  const slope = triangleHeight / triangleWidth;
  const x = targetWidth / 2;

  return (slope * x) / 1.5;
}

function initTriangleSlide() {
  const triangles = document.querySelector(".m-hero__triangles--fg");
  const intro = document.querySelector(".m-paths__intro");
  let scrollStop = getTriangleStop(triangles, intro);

  let scrollTop = window.scrollY || window.pageYOffset;
  requestAnimationFrame(() => {
    scrollTop = window.scrollY || window.pageYOffset;
    scrollStop = getTriangleStop(triangles, intro);
    slideHeroTriangles(triangles, scrollTop, scrollStop)
  });

  window.addEventListener("resize", () => {
    scrollStop = getTriangleStop(triangles, intro);
    requestAnimationFrame(() =>
      slideHeroTriangles(triangles, scrollTop, scrollStop)
    );
  });

  window.addEventListener("scroll", () => {
    scrollTop = window.scrollY || window.pageYOffset;
    requestAnimationFrame(() =>
      slideHeroTriangles(triangles, scrollTop, scrollStop)
    );
  });
}

function slideIntroIn(intro, scrollTop, scrollStart, scrollStop) {
  if (scrollTop > scrollStop) {
    intro.style.marginTop = `${0 - (scrollStop - scrollStart) * 1.25}px`;
  } else if (scrollTop >= scrollStart) {
    intro.style.marginTop = `${0 - (scrollTop - scrollStart) * 1.25}px`;
  } else {
    intro.style.marginTop = `0px`;
  }
}

function getIntroStop(intro, scrollStart) {
  const introHeight = intro.getBoundingClientRect().height;

  return scrollStart + introHeight / 2 / 1.25;
}

function isIntroMobile(intro) {
  return getComputedStyle(intro).display !== 'block';
}

function initIntroSlide() {
  const intro = document.querySelector('.m-paths__intro');
  const introParent = document.querySelector('.m-paths');
  const triangles = document.querySelector('.m-hero__triangles--fg');
  let introScrollStart = getTriangleStop(triangles, intro);
  let introScrollStop = getIntroStop(intro, introScrollStart);

  let isMobile = isIntroMobile(intro);

  let introScrollTop = window.scrollY || window.pageYOffset;

  requestAnimationFrame(() => {
    introScrollStop = getIntroStop(intro, introScrollStart);
    isMobile = isIntroMobile(intro);

    if (!isMobile) {
      slideIntroIn(introParent, introScrollTop, introScrollStart, introScrollStop)
    }
  });

  window.addEventListener("resize", () => {
    introScrollStart = getTriangleStop(triangles, intro);
    introScrollStop = getIntroStop(intro, introScrollStart);
    isMobile = isIntroMobile(intro);

    if (!isMobile) {
      requestAnimationFrame(() =>
        slideIntroIn(introParent, introScrollTop, introScrollStart, introScrollStop)
      );
    }
  });

  window.addEventListener("scroll", () => {
    introScrollTop = window.scrollY || window.pageYOffset;
    if (!isMobile) {
      requestAnimationFrame(() =>
        slideIntroIn(introParent, introScrollTop, introScrollStart, introScrollStop)
      );
    }
  });
}

function overlayFadeIn(overlay, scrollTop, scrollStop) {
  if (scrollTop > scrollStop) {
    overlay.style.opacity = .78;
  } else if (scrollTop >= 15) {
    overlay.style.opacity = (scrollTop - 15) / (scrollStop - 15) * .78;
  } else {
    overlay.style.opacity = 0;
  }
}

function initOverlayFade() {
  const overlay = document.querySelector('.m-hero__overlay');
  const intro = document.querySelector('.m-paths__intro');
  const triangles = document.querySelector('.m-hero__triangles--fg');

  let introScrollStart = getTriangleStop(triangles, intro);
  let overlayStop = getIntroStop(intro, introScrollStart);

  let overlayScrollTop = window.scrollY || window.pageYOffset;
  requestAnimationFrame(() => {
    overlayStop = getIntroStop(intro, introScrollStart);
    overlayFadeIn(overlay, overlayScrollTop, overlayStop);
  });

  window.addEventListener("resize", () => {
    introScrollStart = getTriangleStop(triangles, intro);
    overlayStop = getIntroStop(intro, introScrollStart);

    requestAnimationFrame(() =>
      overlayFadeIn(overlay, overlayScrollTop, overlayStop)
    );
  });

  window.addEventListener("scroll", () => {
    overlayScrollTop = window.scrollY || window.pageYOffset;
    requestAnimationFrame(() =>
    overlayFadeIn(overlay, overlayScrollTop, overlayStop)
    );
  });
}

let vLogoTransition = 0;

function logoFadeOut(logo, logoWords) {
  vLogoTransition = 1;

  anime({
    targets: logoWords,
    opacity: 0,
    duration: 300,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      logo.style.width = '44px';
      vLogoTransition = 0;
    }
  });
}

function logoFadeIn(logo, logoWords) {
  vLogoTransition = 1;

  logo.removeAttribute('style');
  anime({
    targets: logoWords,
    opacity: 1,
    duration: 300,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => vLogoTransition = 0
  });
}

function logoFadeToggle(logo, logoWords, scrollTop, scrollStop) {
  if (vLogoTransition) return;

  if (scrollTop > scrollStop) {
    if (logo.classList.contains('header__logo--small')) return;
    logo.classList.add('header__logo--small');
    logoFadeOut(logo, logoWords);
  } else {
    if (!logo.classList.contains('header__logo--small')) return;
    logo.classList.remove('header__logo--small');
    logoFadeIn(logo, logoWords);
  }
}

function getLogoStop(hero, intro) {
  const heroHeight = hero.getBoundingClientRect().height;
  const introHeight = intro.getBoundingClientRect().height / 2;

  return heroHeight - introHeight - 92;
}

function useFade(header) {
  return getComputedStyle(header).backgroundColor !== 'rgb(255, 255, 255)';
}

function initLogoFade() {
  const logo = document.querySelector('.header__logo');
  const logoWords = logo.querySelector('.logo-text');
  const hero = document.querySelector('.m-hero');
  const intro = document.querySelector('.m-paths__intro');
  const header = document.querySelector('.header');

  let scrollTop = window.scrollY || window.pageYOffset;
  let scrollStop = getLogoStop(hero, intro);
  let fadeLogo = useFade(header);

  requestAnimationFrame(() => {
    scrollStop = getLogoStop(hero, intro);
    fadeLogo = useFade(header);

    if (fadeLogo) {
      logoFadeToggle(logo, logoWords, scrollTop, scrollStop);
    }
  });

  window.addEventListener('resize', () => {
    scrollStop = getLogoStop(hero, intro);
    fadeLogo = useFade(header);

    if (fadeLogo) {
      logoFadeToggle(logo, logoWords, scrollTop, scrollStop);
    }
  });

  window.addEventListener('scroll', () => {
    scrollTop = window.scrollY || window.pageYOffset;
    if (fadeLogo) {
      logoFadeToggle(logo, logoWords, scrollTop, scrollStop);
    }
  });
}

function columnsSlideDown(columns, scrollTop, scrollStart) {
  const progress = (scrollTop - scrollStart) * .375 / 100;
  if (progress > 1) {
    columns.style.transform = `scaleY(1)`;
  } else if (scrollTop >= scrollStart) {
    columns.style.transform = `scaleY(${progress})`;
  } else {
    columns.style.transform = `scaleY(0)`;
  }
}

function isColumnMobile(columns) {
  return getComputedStyle(columns).display === 'none';
}

function initColumnsSlide() {
  const columns = document.querySelector('.m-paths__comparison-cols');
  const intro = document.querySelector('.m-paths__intro');
  const triangles = document.querySelector('.m-hero__triangles--fg');

  let introScrollStart = getTriangleStop(triangles, intro);
  let columnsStart = getIntroStop(intro, introScrollStart);
  let isMobile = isColumnMobile(columns);

  let columnsScrollTop = window.scrollY || window.pageYOffset;
  requestAnimationFrame(() => {
    introScrollStart = getTriangleStop(triangles, intro);
    columnsStart = getIntroStop(intro, introScrollStart);
    isMobile = isColumnMobile(columns);

    if (!isMobile) {
      columnsSlideDown(columns, columnsScrollTop, columnsStart);
    }
  });

  window.addEventListener("resize", () => {
    introScrollStart = getTriangleStop(triangles, intro);
    columnsStart = getIntroStop(intro, introScrollStart);
    isMobile = isColumnMobile(columns);

    if (!isMobile) {
      requestAnimationFrame(() =>
        columnsSlideDown(columns, columnsScrollTop, columnsStart)
      );
    }
  });

  window.addEventListener("scroll", () => {
    columnsScrollTop = window.scrollY || window.pageYOffset;
    if (!isMobile) {
      requestAnimationFrame(() =>
        columnsSlideDown(columns, columnsScrollTop, columnsStart)
      );
    }
  });
}

function getTableStart(comparison, intro, triangles, hero) {
  const winHeight = window.innerHeight;
  const introHeight = intro.getBoundingClientRect().height;
  const heroHeight = hero.getBoundingClientRect().height;
  const comparisonHeight = comparison.getBoundingClientRect().height;

  const introScrollStart = getTriangleStop(triangles, intro);
  const columnsStart = getIntroStop(intro, introScrollStart);

  const comparisonStartStatic = heroHeight + introHeight / 2;
  const comparisonStart = comparisonStartStatic - columnsStart;

  const winRemainder = winHeight - comparisonStart;
  const targetPercentage = winRemainder / comparisonHeight;

  return targetPercentage * 100 / .375 + columnsStart + .02 * winHeight + 15;
}

function tableSlideUp(table, scrollTop, scrollStart) {
  const progress = (scrollTop - scrollStart) / 100;
  const slideProgress = 125 - progress * 125;

  if (progress > 1) {
    [...table].forEach((cell) => {
      cell.style.transform = `translateY(0px)`;
      cell.style.opacity = 1;
    });
  } else if (scrollTop >= scrollStart) {
    [...table].forEach((cell) => {
      cell.style.transform = `translateY(${slideProgress}px)`;
      cell.style.opacity = progress;
    });
  } else {
    [...table].forEach((cell) => {
      cell.style.transform = `translateY(125px)`;
      cell.style.opacity = 0;
    });
  }
}

function initTableSlide() {
  const columns = document.querySelector('.m-paths__comparison-cols');
  const hero = document.querySelector('.m-hero');
  const triangles = document.querySelector('.m-hero__triangles--fg');
  const intro = document.querySelector('.m-paths__intro');
  const comparison = document.querySelector('.m-paths__comparison');
  const table = document.querySelectorAll('.m-paths__comparison > *:not(.m-paths__comparison-cols)');

  let tableStart = getTableStart(comparison, intro, triangles, hero);
  let tableScrollY = window.scrollY || window.pageYOffset;
  let isMobile = isColumnMobile(columns);

  requestAnimationFrame(() => {
    tableStart = getTableStart(comparison, intro, triangles, hero);
    isMobile = isColumnMobile(columns);

    if (!isMobile) {
      tableSlideUp(table, tableScrollY, tableStart);
    }
  });

  window.addEventListener("resize", () => {
    tableStart = getTableStart(comparison, intro, triangles, hero);
    isMobile = isColumnMobile(columns);

    if (!isMobile) {
      requestAnimationFrame(() =>
        tableSlideUp(table, tableScrollY, tableStart)
      );
    }
  });

  window.addEventListener("scroll", () => {
    tableScrollY = window.scrollY || window.pageYOffset;
    if (!isMobile) {
      requestAnimationFrame(() =>
        tableSlideUp(table, tableScrollY, tableStart)
      );
    }
  });
}

let headerAnimating = 0;
function headerHide(header, scrollTop, dir) {
  if (headerAnimating) return;
  if (scrollTop > 100 && !header.classList.contains('header--hidden') && dir === 'down') {
    headerAnimating = 1;
    anime({
      targets: header,
      translateY: '-100%',
      duration: 300,
      easing: 'cubicBezier(0, 0, .58, 1)',
      complete: () => {
        header.classList.add('header--hidden');
        header.removeAttribute('style');
        headerAnimating = 0;
      }
    });
  } else if (header.classList.contains('header--hidden') && dir === 'up') {
    if (dropFormOpen) return;
    headerAnimating = 1;
    anime.set(header, {translateY: '-100%'})
    anime({
      targets: header,
      translateY: 0,
      duration: 300,
      easing: 'cubicBezier(0, 0, .58, 1)',
      complete: () => {
        header.classList.remove('header--hidden');
        header.removeAttribute('style');
        headerAnimating = 0;
      }
    });
  }
}

function initHeaderHide() {
  const header = document.querySelector('.header');
  let isMobile = useFade(header);

  let headerScrollY = window.scrollY || window.pageYOffset;
  let oldHeaderScrollY = headerScrollY;
  let dir = 'down';

  requestAnimationFrame(() => {
    isMobile = useFade(header);
  });

  window.addEventListener("resize", () => {
    isMobile = useFade(header);
  });

  window.addEventListener("scroll", (e) => {
    headerScrollY = window.scrollY || window.pageYOffset;
    dir = headerScrollY > oldHeaderScrollY ? 'down' : 'up';

    if (!isMobile) {
      requestAnimationFrame(() =>
        headerHide(header, headerScrollY, dir)
      );
    }
    oldHeaderScrollY = headerScrollY;
  });
}

[...document.querySelectorAll('.a-tabs__nav-link')].forEach((tab) => {
  tab.addEventListener('click', function(e) {
    e.preventDefault();
    const target = this.getAttribute('href');
    const el = document.querySelector(target);
    const currentEl = document.querySelector('.a-tabs__tab--active');
    const currentLink = document.querySelector('.a-tabs__nav-link--active');

    currentEl.classList.remove('a-tabs__tab--active');
    el.classList.add('a-tabs__tab--active');

    currentLink.classList.remove('a-tabs__nav-link--active');
    this.classList.add('a-tabs__nav-link--active');
  });
});

function prepSelects() {
  const selects = document.querySelectorAll('select');
  [...selects].forEach((select) => {
    if (select.parentNode.classList.contains('v-select')) return;
    const wrap = document.createElement('span');
    wrap.classList.add('v-select');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
  });
}

document.querySelector('.footer__to-top').addEventListener('click', (e) => {
  e.preventDefault();
  anime({
    targets: 'html, body',
    scrollTop: 0,
    duration: 800,
    easing: 'easeOutQuad'
  });
});

function hideScrollBar() {
  const scrollTest = document.createElement('div');
  document.querySelector('body').append(scrollTest);
  scrollTest.style.width = '100vw';
  const widthWide = scrollTest.getBoundingClientRect().width;
  scrollTest.style.width = '100%';
  const widthSmall = scrollTest.getBoundingClientRect().width;

  const scrollWidth = widthWide - widthSmall;
  scrollTest.remove();

  document.querySelector('.a-dropform__inner').style.width = `calc(100% + ${scrollWidth}px)`;
}

function openDropdown(button) {
  dropFormOpen = 1;

  const drop = document.querySelector('.a-dropform');
  const dropInner = drop.querySelector('.a-dropform__inner');
  const buttonLabel = button.querySelector('.header__form-trigger-label');

  const dropWidth = drop.getBoundingClientRect().width;

  const buttonWidth = button.getBoundingClientRect().width;
  const buttonHeight = button.getBoundingClientRect().height;

  button.style.height = buttonHeight;

  const overlay = document.querySelector('.drop-overlay');
  const header = document.querySelector('.header');
  overlay.classList.add('drop-overlay--open');
  header.classList.add('header--hidden');

  anime({
    targets: button,
    width: dropWidth,
    backgroundColor: '#30384d',
    duration: 250,
    easing: 'easeInQuad',
    complete: () => {
      button.classList.add('header__form-trigger--open');

      anime.set(drop, {
        scaleY: 0
      });

      anime({
        targets: drop,
        scaleY: 1,
        duration: 500,
        easing: 'cubicBezier(0, 0, .58, 1)',
        complete: () => button.removeAttribute('style')
      });

      anime.set(dropInner, {
        opacity: 0,
        translateY: 65
      });

      anime({
        targets: dropInner,
        translateY: 0,
        opacity: 1,
        duration: 500,
        delay: 500,
        easing: 'cubicBezier(0, 0, .58, 1)',
        complete: () => {
          drop.classList.add('a-dropform--open');
          dropInner.style.transform = '';
          dropInner.style.opacity = '';
          drop.removeAttribute('style');
        }
      });
    }
  });

  anime({
    targets: buttonLabel,
    opacity: 0,
    duration: 250,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => buttonLabel.removeAttribute('style')
  });
}

function closeDropdown() {
  dropFormOpen = 0;

  const drop = document.querySelector('.a-dropform');
  const dropInner = drop.querySelector('.a-dropform__inner');
  const button = document.querySelector('.header__form-trigger');
  const buttonLabel = button.querySelector('.header__form-trigger-label');

  const dropWidth = drop.getBoundingClientRect().width;

  const buttonWidth = button.getBoundingClientRect().width;
  const buttonHeight = button.getBoundingClientRect().height;

  button.style.width = dropWidth + 'px';
  button.style.height = buttonHeight + 'px';

  const overlay = document.querySelector('.drop-overlay');
  const header = document.querySelector('.header');
  overlay.classList.remove('drop-overlay--open');
  header.classList.remove('header--hidden');

  anime({
    targets: dropInner,
    translateY: 65,
    opacity: 0,
    duration: 500,
    easing: 'cubicBezier(0, 0, .58, 1)'
  });

  anime({
    targets: drop,
    scaleY: 0,
    duration: 500,
    delay: 350,
    easing: 'easeInCubic',
    complete: () => {
      drop.classList.remove('a-dropform--open');
      dropInner.style.transform = '';
      dropInner.style.opacity = '';
      drop.removeAttribute('style');

      anime({
        targets: button,
        width: buttonWidth,
        backgroundColor: '#4b596d',
        duration: 250,
        easing: 'cubicBezier(0, 0, .58, 1)',
        complete: () => {
          button.classList.remove('header__form-trigger--open');
          button.removeAttribute('style');
        }
      });

      anime({
        targets: buttonLabel,
        opacity: 1,
        duration: 250,
        easing: 'cubicBezier(0, 0, .58, 1)',
        complete: () => {
          buttonLabel.removeAttribute('style');
        }
      });
    }
  });
}

let dropFormOpen = 0;

function mobileOpenDropdown(button) {
  const drop = document.querySelector('.a-dropform');
  const dropInner = drop.querySelector('.a-dropform__inner');
  const dropHeight = dropInner.getBoundingClientRect().height;
  const header = document.querySelector('.header');
  const overlay = document.querySelector('.drop-overlay');

  button.classList.add('header__form-trigger--open');

  dropFormOpen = 1;

  anime.set(overlay, {
    display: 'block',
    opacity: 0
  });

  anime({
    targets: overlay,
    opacity: 1,
    duration: 500,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      overlay.classList.add('drop-overlay--open');
      overlay.removeAttribute('style');
    }
  });

  anime({
    targets: header,
    translateY: '-100%',
    duration: 300,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      header.classList.add('header--hidden');
      header.removeAttribute('style');
    }
  });

  anime({
    targets: drop,
    height: dropHeight,
    duration: 500,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      drop.classList.add('a-dropform--open');
      drop.removeAttribute('style');
    }
  });
}

function mobileCloseDropdown(button) {
  const drop = document.querySelector('.a-dropform');
  const dropInner = drop.querySelector('.a-dropform__inner');
  const dropHeight = dropInner.getBoundingClientRect().height;
  const header = document.querySelector('.header');
  const overlay = document.querySelector('.drop-overlay');

  button.classList.remove('header__form-trigger--open');

  dropFormOpen = 0;

  anime.set(header, {translateY: '-100%'});

  anime.set(overlay, {
    opacity: 1
  });

  anime({
    targets: overlay,
    opacity: 0,
    duration: 500,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      overlay.classList.remove('drop-overlay--open');
      overlay.removeAttribute('style');
    }
  });

  anime({
    targets: header,
    translateY: 0,
    duration: 300,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      header.classList.remove('header--hidden');
      header.removeAttribute('style');
    }
  });

  anime({
    targets: drop,
    height: 0,
    duration: 500,
    easing: 'cubicBezier(0, 0, .58, 1)',
    complete: () => {
      drop.classList.remove('a-dropform--open');
      drop.removeAttribute('style');
    }
  });
}

function isFormMobile(drop) {
  return getComputedStyle(drop).position === 'relative';
}

document.querySelector('.header__form-trigger').addEventListener('click', function() {
  const form = document.querySelector('.a-dropform');
  const mobile = isFormMobile(form);
  if (this.classList.contains('header__form-trigger--open')) {
    if (mobile) {
      mobileCloseDropdown(this);
    } else {
      closeDropdown(this);
    }
  } else {
    if (mobile) {
      mobileOpenDropdown(this);
    } else {
      openDropdown(this);
    }
  }
});

document.querySelector('.a-dropform__close').addEventListener('click', function(){
  const form = document.querySelector('.a-dropform');
  const mobile = isFormMobile(form);
  const button = document.querySelector('.header__form-trigger');

  if (mobile) {
    mobileCloseDropdown(button);
  } else {
    closeDropdown();
  }
});

function getNextSiblings(el, filter, label) {
  var siblings = [];
  while (el= el.nextSibling) { if (!filter || filter(el, label)) siblings.push(el); }
  return siblings;
}

function filterByClass(el, label) {
  const correctClass = el.classList && el.classList.contains('m-paths__comparison-content');

  const correctLabel = typeof el.getAttribute === 'function' && el.getAttribute('data-filter') === label;

  return correctClass && correctLabel;
}

[...document.querySelectorAll('.m-paths__comparison-toggle')].forEach((toggle) => toggle.addEventListener('click', function(){
  const el = this;
  const header = this.parentNode;
  const filter = el.getAttribute('data-filter');
  const content = getNextSiblings(header, filterByClass, filter);

  const wrap = document.createElement('div');
  wrap.classList.add('vtemp-wrap');
  wrap.style.overflow = 'hidden';

  content[0].parentNode.insertBefore(wrap, content[0]);
  content.forEach((item) => {
    item.style.display = 'block';
    wrap.appendChild(item)
  });

  const selects = document.querySelectorAll('select[name="interest"]');
  let sVal;
  if (filter === 'member-associates') {
    sVal = 'Member Associate';
  } else {
    sVal = 'SIOR designation';
  }

  if (el.classList.contains('m-paths__comparison-toggle--open')) {
    el.classList.remove('m-paths__comparison-toggle--open');

    [...selects].forEach((select)=>select.value = '');

    anime({
      targets: wrap,
      height: 0,
      duration: 400,
      easing: 'cubicBezier(0, 0, .58, 1)',
      complete: () => {
        content.forEach((item, i) => {
          item.classList.remove('m-paths__comparison-content--open');
          item.removeAttribute('style');
          wrap.parentNode.insertBefore(item, wrap);
          if (i + 1 === content.length) {
            wrap.remove();
          }
        });
      }
    });
  } else {
    const otherOpen = document.querySelector('.m-paths__comparison-toggle--open');

    [...selects].forEach((select)=>select.value = sVal);

    if (otherOpen) {
      const header2 = otherOpen.parentNode;
      const filter2 = otherOpen.getAttribute('data-filter');
      const content2 = getNextSiblings(header2, filterByClass, filter2);

      const wrap2 = document.createElement('div');
      wrap2.classList.add('vtemp-wrap');
      wrap2.style.overflow = 'hidden';

      content2[0].parentNode.insertBefore(wrap2, content2[0]);
      content2.forEach((item) => {
        item.style.display = 'block';
        wrap2.appendChild(item)
      });

      otherOpen.classList.remove('m-paths__comparison-toggle--open');

      anime({
        targets: wrap2,
        height: 0,
        duration: 400,
        easing: 'cubicBezier(0, 0, .58, 1)',
        complete: () => {
          content2.forEach((item, i) => {
            item.classList.remove('m-paths__comparison-content--open');
            item.removeAttribute('style');
            wrap2.parentNode.insertBefore(item, wrap2);
            if (i + 1 === content2.length) {
              wrap2.remove();
            }
          });
        }
      });
    }

    const targetHeight = wrap.getBoundingClientRect().height;
    anime.set(wrap, {height: 0});

    el.classList.add('m-paths__comparison-toggle--open');

    anime({
      targets: wrap,
      height: targetHeight,
      duration: 400,
      easing: 'cubicBezier(0, 0, .58, 1)',
      complete: () => {
        content.forEach((item, i) => {
          item.classList.add('m-paths__comparison-content--open');
          item.removeAttribute('style');
          wrap.parentNode.insertBefore(item, wrap);
          if (i + 1 === content.length) {
            wrap.remove();
          }
        });
      }
    });
  }
}));

window.addEventListener('message', (e) => {
  if (e.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
    const fId = e.data.id;
    const message = document.querySelector(`.hs-form-${fId}`);

    const messageParent = message.parentNode;
    const messageGrandparent = messageParent.parentNode;

    if (messageGrandparent.classList.contains('m-connect__content-inner')) {
      const text = messageGrandparent.querySelector('p:first-of-type');
      text.remove();

      const title = messageGrandparent.querySelector('h3:first-of-type');
      title.innerText = `Success! You've taken the next step toward membership.`;
    } else if (messageGrandparent.classList.contains('a-dropform__inner')) {
      const title = messageGrandparent.querySelector('h2:first-of-type');
      title.innerText = `Success! You've taken the next step toward membership.`;
    }
  }
})


window.addEventListener("load", function(){
  vHeroAnimation();
  var evt = window.document.createEvent('UIEvents');
  evt.initUIEvent('resize', true, false, window, 0);
  window.dispatchEvent(evt);
  prepSelects();
});
document.addEventListener('DOMContentLoaded', function(){
  vPrepHeroAnimation();
  initTriangleSlide();
  initIntroSlide();
  initOverlayFade();
  initLogoFade();
  initColumnsSlide();
  initTableSlide();
  prepSelects();
  hideScrollBar();
  initHeaderHide();
});